<template>
    <div>
        <PlainTextField
            v-if="plainText"
            :model-value="iname"
            :title="title"
            clarity-class="clarity-mask"
            :edit-style="editStyle"
        />
        <VeeField
            v-else
            v-slot="{value:fieldValue, handleChange, handleBlur, errors}"
            v-model="iname"
            :name="!!name ? name : title"
            :rules="{ required: { allowFalse: false }, max: { length: maxLength}}"
            :valdiate-on-mount="immediate"
            @update:model-value="$emit('update:modelValue', iname)"
            @blur="$emit('update:modelValue', iname)"
        >
            <div>
                <div
                    class="mt-[20px] md:mt-[30px] mb-[10px] font-medium"
                    :class="[
                        {'text-pink-800': !!errors[0]}, 
                        !memberStyle ? 'text-black' : 'mt-4'
                    ]"
                >
                    {{ title }} 
                    <span
                        v-if="!memberStyle"
                        class="text-pink-800"
                    >*</span>
                </div>
                <div
                    class="mt-2"
                    :class="[{'xl:mt-0': !memberStyle}]"
                >
                    <FormTextField
                        :id="id"
                        :model-value="fieldValue"
                        :max-length="maxLength"
                        :error="!!errors[0]"
                        :error-message="errors[0]"
                        :placeholder="placeholder"
                        :uppercase="false"
                        :disabled="disabled"
                        @keyup="handleBlur"
                        @update:model-value="handleChange"
                    />
                </div>
            </div>
        </VeeField>
    </div>
</template>

<script>
import FormTextField from '@/components/forms/TextField';
import PlainTextField from '@/components/forms/PlainTextField.vue';

export default{
    name: 'NameField',
    components: { FormTextField, PlainTextField, },
    props: {
        // 編輯style開關
        editStyle: {
            type: Boolean,
            default: false
        },
        // 直接判定錯誤開關
        immediate: {
            type: Boolean,
            default: false
        },
        // 為純顯示非input
        plainText: {
            type: Boolean,
            default: false,
        },
        // 內容
        modelValue:{
            type: String,
            default: '', 
        },
        // input id
        id: {
            type: String,
            default: 'Name',
        },
        // 欄位名稱
        title: {
            type: String,
            default: '姓名'
        },
        // 檢核覽位名
        name: {
            type: String,
            default: ''
        },
        // 會員資料style
        memberStyle: {
            type: Boolean,
            default: false,
        },
        // 未輸入時顯示的文字
        placeholder: {
            type: String,
            default: '',
        },
        // 是否不能被點選
        disabled: {
            type: Boolean,
            default: false,
        },
        // 檢核最長長度
        maxLength: {
            type: Number,
            default: 120
        },
        // 檢定用模式
        mode: {
            type: String,
            default: 'aggressive',
        },
    },
    emits: ['update:modelValue'],
    data() {
        /** @param {String} iname 姓名 */
        return {
            iname: this.modelValue,
        };
    },
    watch: {
        // Need for Pas related names
        modelValue(newValue){
            this.iname = newValue;
        }
    }
};
</script>